import styled from '@emotion/styled'
import * as React from 'react'

import { useCollapse } from '../../../../../behaviour/Collapse'
import DropdownIcon from '../../../../../core/DropdownIcon'
import Container from '../../../../../layout/Container'
import Separator from '../../../../../layout/Separator'
import Icon from '../../../../../media/Icon'

const Button = styled(Container)`
    display: flex;
    width: 100%;
    height: 60px;
    align-items: center;
    -webkit-appearance: none;
    outline: none;
`

const ToggleIcon = styled(Icon)`
    width: 0.8rem;
    height: auto;
    margin-left: auto;
    margin-right: 12px;
`

const FilterContainer = styled(Container)`
    margin-bottom: 10px;
`

const Label = styled.div`
    flex: 1;
    font-size: 0.85em;
`

interface Props {
    label: React.ReactNode
    children: React.ReactNode
    className?: string
}

const FilterButton = ({ label, children, className }: Props) => {
    const [getCollapseProps, getToggleProps, isOpen] = useCollapse({})

    return (
        <>
            <Button
                className={className}
                {...getToggleProps()}
                data-testid="filterButton"
            >
                <Label>{label}</Label>
                <ToggleIcon
                    component={DropdownIcon}
                    title=""
                    style={{ transform: `rotate(${isOpen ? 180 : 0}deg)` }}
                />
            </Button>

            <FilterContainer {...getCollapseProps()}>
                {children}
            </FilterContainer>
            <Separator />
        </>
    )
}

export default FilterButton
